import { Person } from "./person";
import { Position } from "./position";
import { Status } from "./status";

export class Contact {
  id: number;
  person: Person = new Person();
  email?: string;
  phone?: string;
  position?: Position;  
  status: Status = new Status();
  createdAt: Date = new Date();
  updatedAt: Date;
}
